import React, { Component, Fragment } from 'react'
import ProgressMeterWithLogo from 'components/ProgressMeterWithLogo'
import { OnboardingHeader } from 'components/OnboardingHeader'
import OnboardingBackButton from 'components/OnboardingBackButton'
import { Input, Button } from '@drifthq/tide-core'
import config from 'config'
import { api } from "modules/playbook/api"
import { debounce } from 'debounce'

import './style.css'

const ERROR_TEXT = "Sorry, this subdomain is already taken"
const DEBOUNCE_IN_MS = 400

class OnboardingPlaybookCLPSubdomainStep extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isEditedDomainInvalid: props.landingPageSubdomain ? false : true,
      editedSubdomain: props.landingPageSubdomain ? props.landingPageSubdomain : props.handle,
    }
  }

  debouncedPatch = debounce(async (domain) => {
    try {
      const data = await api.updateLandingPageSubdomain(domain)
      this.doSuccess(data.subdomain)
    } catch (e) {
      const domainWasTaken = e && e.status === 409
      this.doFail(domainWasTaken)
    }
  }, DEBOUNCE_IN_MS)

  onUpdateSubdomain = event => {
    const subdomain = event.target.value.trim()
    this.setState({
      editedSubdomain: subdomain
    }, () => this.debouncedPatch(subdomain))
  }

  doSuccess = (newSavedDomain) => {
    this.setState({
      isEditedDomainInvalid: false,
    })
    const { actions } = this.props
    actions.setCLPSubdomain(newSavedDomain)
  }

  doFail = (domainWasTaken) => {
    this.setState({
      isEditedDomainInvalid: domainWasTaken,
    })
  }

render() {
  const {
    onContinue,
    stepCount,
    index
  } = this.props

  const {
    editedSubdomain,
    isEditedDomainInvalid
  } = this.state

  return (
    <Fragment>
      <ProgressMeterWithLogo currentLength={index} maxLength={stepCount - 1} />
      <OnboardingHeader
        title="Create a custom subdomain for your landing page"
        description="You can always change this later under your bot settings"
      />
      <div className="onboarding-playbook-clp-subdomain--input-wrapper">
      <Input
        size="large"
        value={editedSubdomain}
        onChange={this.onUpdateSubdomain}
        placeholder="my-subdomain"
        required
        className="onboarding-playbook-clp-subdomain--input"
      />
        <Button disabled="true" className="onboarding-playbook-clp-subdomain--link-button">{config.PAGES_HOST}</Button>
      </div>
      {isEditedDomainInvalid && <div className="onboarding-playbook-clp-subdomain--error">{ERROR_TEXT}</div>}

      <Button disabled={!editedSubdomain || isEditedDomainInvalid} className="onboarding-playbook-clp-subdomain--next-button" size="large" onClick={onContinue}>
        Next
      </Button>

      <OnboardingBackButton/>

    </Fragment>
  )
}
}

export default OnboardingPlaybookCLPSubdomainStep


// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookCLPSubdomainStep/index.js